const initialState = {
  gettingAddress: false,
  address: {}
}

export const SET_ADDRESS = 'SET_ADDRESS'
export const SET_GETTING_ADDRESS = 'SET_GETTING_ADDRESS'

export default function address(state = initialState, action) {
  switch (action.type) {
    case SET_GETTING_ADDRESS: {
      const { gettingAddress } = action
      return Object.assign({}, state, { gettingAddress })
    }
    case SET_ADDRESS: {
      const { address } = action
      return Object.assign({}, state, { address })
    }
    default: {
      return state
    }
  }
}